import { Box, Typography } from '@mui/material';
import CardContainer from '../../../components/cards/layout/CardContainer';
import CardGrid from '../../../components/cards/layout/CardGrid';
import PictureNameCard from '../../../components/cards/PictureNameCards/PictureNameCard';
import { RequestController } from './ExtendTimeCorrection';
import {
  requestTypesIcons,
  requestTypesStrings,
  vacationTypes,
} from '../../../components/special/requestTypes';
import { useTranslation } from 'react-i18next';
import { useConfig } from '../../../api/api';
import { useState } from 'react';
import Feedback from '../../../components/special/Feedback';
import DateLabel from '../../../components/label/DateLabel';
import { TimeLabelElement } from '../../time-manager/user-entries/timeline/TimeInfo';

export const ExtendVacation = ({ request, onUpdate }) => {
  const { t } = useTranslation();
  const config = useConfig();

  // feedback
  const [alertState, setAlertState] = useState({
    alertOpen: false,
    alertType: 'info',
    alertText: 'test',
  });
  function handleAlertOpen(text, type) {
    setAlertState({ alertOpen: true, alertText: text, alertType: type });
  }
  const { values, user } = request;
  const requester = request.requestedBy || user;

  const vacationTotal = user?.vacationTotal ?? 0;
  const vacationTaken = user?.vacationTaken ?? 0;
  const vacationRequested = user?.vacationRequested ?? 0;
  const vacationPending = Math.max(vacationRequested - vacationTaken, 0);
  const vacationAvailable = Math.max(vacationTotal - vacationRequested, 0);
  const hasVacationInfo = request.type === 'vacation' && user;

  return (
    <>
      <CardGrid>
        <CardContainer span={5} className="">
          <Typography
            variant="h3"
            className="flex items-center justify-center gap-2"
          >
            {request.type === 'vacation' && values.type
              ? vacationTypes[values.type].icon
              : requestTypesIcons[request.type]}
            {request.type === 'vacation' && values.type
              ? t(vacationTypes[values.type].label)
              : t(requestTypesStrings[request.type])}
          </Typography>
          <Typography variant="h6">
            <DateLabel date={request.values.startDate} />
            {' - '}
            <DateLabel date={request.values.endDate} />
          </Typography>
        </CardContainer>
        {hasVacationInfo && (
          <CardContainer span={5}>
            <Typography variant="h6" className="pb-1">
              {t('Vacation Balance')}
            </Typography>
            <Box className="flex justify-evenly flex-wrap w-full gap-2">
              <TimeLabelElement
                src="/assets/uploads/times/holiday.webp"
                label={t('Total')}
                totalTime={vacationTotal}
                percent={1}
                hidePercent
                format="day"
                sufix={vacationTotal === 1 ? t('Day') : t('Days')}
              />
              <TimeLabelElement
                src="/assets/uploads/times/worked.webp"
                label={t('Taken')}
                totalTime={vacationTaken}
                percent={1}
                hidePercent
                format="day"
                sufix={vacationTaken === 1 ? t('Day') : t('Days')}
              />
              <TimeLabelElement
                src="/assets/uploads/times/vacation.webp"
                label={t('Pending')}
                totalTime={vacationPending}
                percent={1}
                hidePercent
                format="day"
                sufix={vacationPending === 1 ? t('Day') : t('Days')}
              />
              <TimeLabelElement
                src="/assets/uploads/times/account.webp"
                label={t('Available')}
                totalTime={vacationAvailable}
                percent={1}
                hidePercent
                format="day"
                sufix={vacationAvailable === 1 ? t('Day') : t('Days')}
              />
            </Box>
          </CardContainer>
        )}
        <PictureNameCard
          data={requester}
          type="user"
          title={t('Requester')}
          pictureUrl={requester.picture ? requester.picture.temporaryUrl : ''}
          name={`${requester.firstName} ${requester.lastName}`}
          mail={requester.email}
          phone={requester.phone}
          position={requester.position}
        />

        <CardContainer>
          <RequestController
            request={request}
            onUpdate={onUpdate}
            onFeedback={handleAlertOpen}
          />
        </CardContainer>
        {request.processedBy && (
          <PictureNameCard
            data={request.processedBy}
            type="user"
            title={t('Processor')}
            pictureUrl={
              request.processedBy.picture
                ? request.processedBy.picture.temporaryUrl
                : ''
            }
            name={`${request.processedBy.firstName} ${request.processedBy.lastName}`}
            mail={request.processedBy.email}
            phone={request.processedBy.phone}
            position={request.processedBy.position}
          />
        )}
      </CardGrid>
      <Feedback setState={setAlertState} state={alertState} />
    </>
  );
};
